import OrganizationApi from 'api/organization'

// actions
const actions = {
  // get list of projects income
  members(_, params) {
    return OrganizationApi.members(params)
  },
  logs(_, params) {
    return OrganizationApi.logs(params)
  },
  stats(_, params) {
    return OrganizationApi.stats(params)
  },
  editMember(_, params) {
    return OrganizationApi.editMember(params)
  },
  removeMember(_, params) {
    return OrganizationApi.removeMember(params)
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/organization.js